import { useMutation } from '@apollo/client';
import NEW_BOOKMARK from 'graphql/fragments/NewBookmark.graphql';
import CREATE_BOOKMARK from 'graphql/mutations/bookmarks/CreateBookmark.graphql';

export default function useCreateBookmarkMutation() {
  return useMutation(CREATE_BOOKMARK, {
    update(cache, { data: { createEpubBookmark } }) {
      cache.modify({
        fields: {
          epubBookmarksByEpub(existingBookmarks) {
            const newBookmarkRef = cache.writeFragment({
              data: createEpubBookmark.epubBookmark,
              fragment: NEW_BOOKMARK,
            });

            return {
              __typename: existingBookmarks.__typeName,
              edges: [
                ...existingBookmarks.edges,
                {
                  __typename: 'EpubBookmarkNodeEdge',
                  node: newBookmarkRef,
                },
              ],
            };
          },
        },
      });
    },
  });
}
